/**
 * Fixed floating WhatsApp button - visible on all pages while scrolling
 */

import React from 'react';

const WHATSAPP_NUMBER = '96894448686'; // +968 9444 8686
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const WhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-14 h-14 bg-[#25d366] text-white rounded-full flex items-center justify-center shadow-lg z-[9999] hover:scale-110 hover:shadow-xl transition-transform transition-shadow"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        fill="currentColor"
        className="w-8 h-8"
        aria-hidden
      >
        <path d="M16 0C7.164 0 0 7.164 0 16c0 2.825.736 5.49 2.023 7.784L.068 31.14l7.49-1.966A15.91 15.91 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.614 0-5.078-.682-7.22-1.872l-.516-.304-2.676.702.714-2.614-.422-.538A13.27 13.27 0 012.667 16c0-7.364 5.969-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.272-10.114c-.396-.198-2.344-1.156-2.708-1.292-.364-.136-.628-.198-.892.198-.264.396-1.024 1.292-1.254 1.556-.23.264-.46.298-.856.1-.396-.2-1.672-.617-3.188-1.964-1.178-1.048-1.97-2.344-2.2-2.74-.23-.396-.025-.61.173-.806.178-.178.396-.46.594-.69.198-.23.264-.396.396-.66.132-.264.066-.496-.033-.694-.1-.198-.892-2.148-1.224-2.94-.322-.766-.65-.662-.892-.672l-.76-.014c-.264 0-.69.1-1.056.494-.364.396-1.39 1.358-1.39 3.312 0 1.954 1.424 3.84 1.622 4.108.198.264 2.798 4.266 6.786 5.98.946.406 1.688.65 2.266.832.95.298 1.816.256 2.502.156.764-.114 2.344-.958 2.672-1.884.328-.926.328-1.72.23-1.884-.1-.166-.364-.264-.76-.462z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
